// 来源巡检还是自检
export const ORIGIN_TASK_TYPE = {
    1:"巡店",
    2:"自检",
    3:"临时整改"
}

export const CHECK_STATE = {
    0:"待审批",
    1:"已通过",
    2:"驳回"
}

export const STATE = {
    0:"新建",
    1:"待执行",
    2:"进行中",
    3:"已完成",
    4:"已逾期",
    5:"锁定",
    6:"逾期完成"
}

export const COLOR = {
    0: "#00CCA2",
    1: "#00CCA2",
    2: "#00CCA2",
    3: "#74879B",
    4: "#FE3333",
    5: "#00CCA2",
    6: "#74879B",
    8: "#00CCA2",
    9: "#74879B",
    10: '#FF4786'
}

export const RECTIFICATION_STATE = {
    0:"新建",
    1:"待执行",
    2:"进行中",
    3:"已完成",
    4:"逾期待执行",
    5:"逾期进行中",
    6:"逾期完成",
    8:"待审批",
    9:"审批通过",
    10:"审批驳回"
}

export const SCORE_TYPE_LIST = {
    1: "不计分",
    2: "百分比计分",
    3: "加分模式",
    4: "减分模式",
    5: "大项百分比加分模式"
}

export const ITEM_TYPE_LIST = {
    1: "对错型",
    2: "单选型",
    3: "多选型",
    4: "输入数值",
    5: "输入单行文本",
    6: "输入多行文本",
    8: "日期时间",
    9: "图片"
}

export const ALL_ITEM_TYPES = Object.assign({ 7: "关联业务功能" }, ITEM_TYPE_LIST);

export const IS_SCORE_TYPE = val => {
    const type = Number(val);
    return Number.isInteger && SCORE_TYPES.includes(type);
};

export const SCORE_TYPES = [1,2,3,4];

export const NON_SCORE_TYPES = [5,6,8,9];

export const OPTION_TYPES = [1,2,3];

export const ITEM_KEY_LIST = {
    0: "普通项",
    //1: "关键项",
    2: "致命项",
    3: "一级分组致命项",
    4: "额外加分项",
    5: "额外减分项"
}